module.exports = __webpack_public_path__ + "media/images/flags/16/Algeria-93369a93faad2271e0a995307ea2b2fc.png";